export const CLOSED = 'CLOSED';
export const TERMINATED = 'TERMINATED';
export const ACTIVE = 'ACTIVE';
